// A2-507 — why an upload's refused rows were refused (kept on the upload).
// Its own module: lib/api.js is frozen at its size (tests/loc_ratchet.json).
import { authClient } from "../authApi";

export const getIngestRunFailures = async (runId) =>
  (await authClient.get(`/ingest/${runId}/failures`)).data;
